import { render } from "./EntregaQR.vue?vue&type=template&id=96428528&scoped=true"
import script from "./EntregaQR.vue?vue&type=script&lang=js"
export * from "./EntregaQR.vue?vue&type=script&lang=js"

import "./EntregaQR.vue?vue&type=style&index=0&id=96428528&scoped=true&lang=scss"

import exportComponent from "/builds/aplicaciones_mides/pat_qr/QRreader/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96428528"]])

export default __exports__